<template>
  <div>
    <div class="alert alert-danger " role="alert" v-if='data.isError === true'>
      <button type="button" class="close non-modal-close" @click="data.isError = false">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      {{data.message}}
    </div>

    <div class="alert alert-success" role="alert" v-if='data.isError === "success"'>
      <button type="button" class="close non-modal-close" @click="data.isError = false">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      {{data.message}}
    </div>
  </div>
</template>
<style>
.non-modal-close {
  top: 4.5px!important;
}
</style>
<script>
export default {
  name: "ResponseMessage",
  props: {
    data: Object,
  }
};
</script>
